import { GoogleOAuthProvider } from '@react-oauth/google';
import { useTheme } from 'styled-components';

import { CONSTANTS } from './AuthModal.data';
import { AuthModalPropsT } from './AuthModal.types';
import { AuthModalView } from './AuthModalView';
import { AuthContextProvider } from './context/AuthContext';
import { AuthModalAntdProvider } from './context/AuthModalAntdProvider';

export const AuthModal = ({
  apiBaseUrl,
  onLogin,
  isAuthCloseDisabled,
  isLoginOnly,
  onClose,
  invitationToken,
  prefilledEmail,
  isDesygnerUser = false,
  ...restProps
}: AuthModalPropsT) => {
  const theme = useTheme();

  return (
    <GoogleOAuthProvider clientId={CONSTANTS.googleClientId}>
      <AuthContextProvider
        apiBaseUrl={apiBaseUrl}
        isLoginOnly={!!isLoginOnly}
        isAuthCloseDisabled={!!isAuthCloseDisabled}
        onLogin={onLogin}
        onClose={() => onClose?.()}
        isLoadingView={false}
        invitationToken={invitationToken}
        prefilledEmail={prefilledEmail}
      >
        <AuthModalAntdProvider theme={theme}>
          <AuthModalView
            apiBaseUrl={apiBaseUrl}
            onLogin={onLogin}
            isAuthCloseDisabled={isAuthCloseDisabled}
            isLoginOnly={isLoginOnly}
            onClose={onClose}
            isDesygnerUser={isDesygnerUser}
            {...restProps}
          />
        </AuthModalAntdProvider>
      </AuthContextProvider>
    </GoogleOAuthProvider>
  );
};
